
import LocationCross from "../../../assets/outline/LocationCross.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LocationCrossIcon({ className, dataTestid = "LocationCrossIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LocationCross data-testid={dataTestid} className={classes} {...rest} />
  );
}
